import {
  LucideArchive,
  LucideAward,
  LucideAsterisk,
  LucideArrowDown,
  LucideArrowRight,
  LucideArrowUp,
  LucideBadgeCheck,
  LucideBarChart3,
  LucideBell,
  LucideBuilding2,
  LucideCalendar,
  LucideCircleAlert,
  LucideCircleX,
  LucideContactRound,
  LucideExternalLink,
  LucideEye,
  LucideFileSpreadsheet,
  LucideFilter,
  LucideInfo,
  LucideLoaderCircle,
  LucideMessageCircle,
  LucidePlay,
  LucidePlus,
  LucideRotateCcw,
  LucideSend,
  LucideChevronDown,
  LucideChevronRight,
  LucideChevronsLeft,
  LucideChevronsRight,
  LucideClipboardCheck,
  LucideCircleUser,
  LucideGlobe,
  LucideGraduationCap,
  LucideHelpCircle,
  LucideHome,
  LucideImage,
  LucideInbox,
  LucideLayers,
  LucideLayoutDashboard,
  LucideLock,
  LucideLogOut,
  LucideMegaphone,
  LucideMenu,
  LucideMessageSquare,
  LucideMessageSquareQuote,
  LucideBriefcase,
  LucideCheck,
  LucideClock,
  LucideTrash2,
  LucideFileText,
  LucideMail,
  LucideMapPin,
  LucidePhone,
  LucideTriangleAlert,
  LucideUpload,
  LucideX,
  LucidePanelLeftClose,
  LucidePanelLeftOpen,
  LucidePencil,
  LucidePlane,
  LucideSearch,
  LucideSettings,
  LucideSparkles,
  LucideUserPlus,
  LucideUsers,
  LucideWallet,
  provideLucideIcons,
} from '@lucide/angular';
import type { Provider } from '@angular/core';

export const ADMIN_MENU_ICONS_PROVIDER: Provider = provideLucideIcons(
  LucideLayoutDashboard,
  LucideHome,
  LucideGlobe,
  LucideGraduationCap,
  LucideMessageSquareQuote,
  LucideMessageSquare,
  LucideImage,
  LucideUsers,
  LucideCircleUser,
  LucideMenu,
  LucideSettings,
  LucideLogOut,
  LucidePanelLeftClose,
  LucidePanelLeftOpen,
  LucidePencil,
  LucideMegaphone,
  LucideSearch,
  LucideSparkles,
  LucideBarChart3,
  LucideBell,
  LucideBriefcase,
  LucideCalendar,
  LucideArrowDown,
  LucideArrowRight,
  LucideArrowUp,
  LucideExternalLink,
  LucideEye,
  LucideWallet,
  LucideArchive,
  LucideAward,
  LucideBadgeCheck,
  LucidePlane,
  LucideHelpCircle,
  LucideBuilding2,
  LucideLayers,
  LucideLock,
  LucideChevronDown,
  LucideChevronRight,
  LucideChevronsLeft,
  LucideChevronsRight,
  LucideClipboardCheck,
  LucideUserPlus,
  LucideInbox,
  LucideCheck,
  LucideCircleX,
  LucideClock,
  LucideContactRound,
  LucideFilter,
  LucideMessageCircle,
  LucidePlay,
  LucidePlus,
  LucideRotateCcw,
  LucideSend,
  LucideTrash2,
  LucideFileText,
  LucideMail,
  LucideMapPin,
  LucidePhone,
  LucideUpload,
  LucideAsterisk,
  LucideInfo,
  LucideCircleAlert,
  LucideFileSpreadsheet,
  LucideLoaderCircle,
  LucideTriangleAlert,
  LucideX,
);

export type AdminMenuIconName =
  | 'layout-dashboard'
  | 'home'
  | 'sparkles'
  | 'globe'
  | 'graduation-cap'
  | 'message-square-quote'
  | 'image'
  | 'users'
  | 'circle-user'
  | 'menu'
  | 'settings'
  | 'building-2'
  | 'layers'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevrons-left'
  | 'chevrons-right'
  | 'briefcase'
  | 'inbox'
  | 'user-plus';

export const ADMIN_MENU_ICON_BY_ROUTE: Record<string, AdminMenuIconName> = {
  '/platform/dashboard': 'layout-dashboard',
  '/platform/franchises': 'building-2',
  '/platform/marketing/home': 'home',
  '/platform/success-stories': 'sparkles',
  '/platform/countries': 'globe',
  '/platform/universities': 'graduation-cap',
  '/platform/testimonials': 'message-square-quote',
  '/platform/media': 'image',
  '/platform/leads': 'users',
  '/platform/applicants': 'user-plus',
  '/platform/feature-requests': 'inbox',
  '/platform/crm/lead-statuses': 'briefcase',
  '/platform/crm/applicant-statuses': 'briefcase',
  '/platform/users': 'circle-user',
  '/platform/settings': 'settings',
  '/tenant/dashboard': 'layout-dashboard',
  '/tenant/leads': 'users',
  '/tenant/applicants': 'user-plus',
  '/tenant/staff': 'circle-user',
  '/tenant/settings': 'settings',
};
